import React from 'react';
import NoticeProductList from '../NoticeProductList';

const NoticeProductListWrap = (props) => {
  const { noticeProductList, getList, getExcelDownload, deleteNoticeProduct } = props;

  return (
    <div className="notice-product-list-wrap">
      {/* 상품 공지사항 리스트 */}
      <NoticeProductList
        noticeProductList={noticeProductList}
        getList={getList}
        getExcelDownload={getExcelDownload}
        deleteNoticeProduct={deleteNoticeProduct}
      />
    </div>
  );
};

export default NoticeProductListWrap;
